<template>
  <div class="pt-5 pl-md-5 pb-10">
    <v-skeleton-loader v-if="loading" type="article"></v-skeleton-loader>
    <v-container v-if="!loading" fluid>
      <h1 class="text-h5 mb-5">{{ $t("string680") }}</h1>
      <v-card flat>
        <v-card-text>
          <p v-if="!list.length">{{ $t("string683") }}</p>
          <v-simple-table v-else>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">{{ $t("Status") }}</th>
                  <th class="text-left">{{ $t("PropertyName") }}</th>
                  <th class="text-left">{{ $t("TripDetails") }}</th>
                  <th class="text-left">{{ $t("Reviews") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in list" :key="item._id">
                  <td>
                    <v-chip
                      small
                      class="ma-2"
                      :color="item.active ? 'green' : 'red'"
                      text-color="white"
                    >
                      <span v-if="item.active">{{ $t("stringN611") }}</span>
                      <span v-if="!item.active">{{ $t("stringN612") }}</span>
                    </v-chip>
                  </td>
                  <td>{{ item.property_id.name }}</td>
                  <td>
                    <p>{{ $t("Tripid") }}: {{ item.booking_id._id }}</p>
                    {{ $t("From") }}
                    {{
                      format(
                        new Date(
                          item.booking_id.booking_details.dates[1] + "T00:00"
                        ),
                        "eee, do MMM, yyyy"
                      )
                    }}
                    - {{ $t("Until") }}
                    {{
                      format(
                        new Date(
                          item.booking_id.booking_details.dates[1] + "T00:00"
                        ),
                        "eee, do MMM, yyyy"
                      )
                    }}
                  </td>
                  <td>
                    <table style="width: 100%">
                      <tr>
                        <td class="subtitle-2">
                          <span class="grey--text">{{ $t("rating1") }} :</span>
                          {{ item.rating1 }} / 5
                        </td>
                        <td class="subtitle-2">
                          <span class="grey--text">{{ $t("rating2") }} :</span>
                          {{ item.rating2 }} / 5
                        </td>
                      </tr>
                      <tr>
                        <td class="subtitle-2">
                          <span class="grey--text">{{ $t("rating3") }} :</span>
                          {{ item.rating3 }} / 5
                        </td>
                        <td class="subtitle-2">
                          <span class="grey--text">{{ $t("rating4") }} :</span>
                          {{ item.rating4 }} / 5
                        </td>
                      </tr>
                      <tr>
                        <td class="subtitle-2">
                          <span class="grey--text">{{ $t("rating5") }} :</span>
                          {{ item.rating5 }} / 5
                        </td>
                        <td class="subtitle-2">
                          <span class="grey--text">{{ $t("rating6") }} :</span>
                          {{ item.rating6 }} / 5
                        </td>
                      </tr>
                    </table>

                    <p class="font-italic mt-3">{{ item.comments }}</p>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
      </v-card>
      <WaitDialogComponent :waitDialog="waitDialog" />
    </v-container>
  </div>
</template>

<script>
import WaitDialogComponent from "@/components/layout/WaitDialogComponent.vue";
import timeoutMixin from "@/mixins/timeoutMixin.js";
import ListingService from "@/services/ListingService";
import { format } from "date-fns";

export default {
  name: "ReviewsListComponent",
  components: { WaitDialogComponent },
  mixins: [timeoutMixin],
  data() {
    return {
      format,
      loading: true,
      list: [],
      list1: [],
      mylist: [],
      error: null,
      waitDialog: false
    };
  },
  created: function() {
    ListingService.getReviews({})
      .then(result => {
        this.list = result.data;
        this.loading = false;
      })
      .catch(err => {
        this.error = err.response.data.error;
      });
  }
};
</script>

<style></style>
